import { locale } from '@infinitro/global';
import { derived, get } from 'svelte/store';
import ar from './edited/ar/global.json';
import cs from './edited/cs/global.json';
import de from './edited/de/global.json';
import en from './edited/en/global.json';
import es from './edited/es/global.json';
import fr from './edited/fr/global.json';
import id from './edited/id/global.json';
import it from './edited/it/global.json';
import ja from './edited/ja/global.json';
import ko from './edited/ko/global.json';
import ms from './edited/ms/global.json';
import pt from './edited/pt/global.json';
import ru from './edited/ru/global.json';
import th from './edited/th/global.json';
import tr from './edited/tr/global.json';
import vi from './edited/vi/global.json';
import zh from './edited/zh/global.json';
import { Verbiage } from './keys';
import { loadTranslation, translations } from './translations';
export { locale, Verbiage };
export const locales = [
    'en',
    'cs',
    'de',
    'es',
    'fr',
    'it',
    'ja',
    'ko',
    'pt',
    'ru',
    'tr',
    'th',
    'zh',
    'id',
    'ms',
    'vi',
    'ar'
];
locale.subscribe((language) => {
    loadTranslation(language);
});
const translationsByLocale = {
    ar,
    cs,
    de,
    en,
    es,
    fr,
    id,
    it,
    ja,
    ko,
    ms,
    pt,
    ru,
    tr,
    th,
    vi,
    zh
};
export function translate(key, page = 'global', params = {}) {
    const currentTranslations = get(translations);
    const translationKey = `${page}.${key}`;
    let text = currentTranslations[translationKey] || currentTranslations[key] || key;
    // Replace parameters in the text
    Object.entries(params).forEach(([key, value]) => {
        const safeValue = value ?? '';
        text = text
            ?.replace(new RegExp(`{${key}}`, 'g'), String(safeValue))
            .replace(`[${key}]`, String(safeValue));
    });
    // Remove only the curly braces, keeping their content
    if (text) {
        text = text?.replace(/\{|\}/g, '');
    }
    else {
        console.warn(`Translation key not found: ${translationKey}`);
    }
    return text;
}
export const t = derived([locale, translations], () => (key, page = 'global', vars = {}) => {
    if (!page)
        page = 'global';
    return translate(key, page, vars);
});
// Method that checks if a Verbiage key doesn't exists in the .json translation files
export function checkMissingTranslationsAllLocales() {
    const keys = Object.keys(Verbiage);
    locales.forEach((lang) => {
        const translations = translationsByLocale[lang];
        if (!translations) {
            console.warn(`File does not exist for language: ${lang}`);
            return;
        }
        const missing = keys.filter((key) => !(key in translations));
        if (missing.length > 0) {
            console.warn(`Missing keys in ${lang}/global.json:`, missing);
        }
        else {
            console.log(`All Verbiage keys exist in ${lang}/global.json`);
        }
    });
}
// Method that checks if a .json key doesn't exists in the Verbiage enum for all the .json files
export function checkOrphanTranslationsAllLocales() {
    const enumKeys = new Set(Object.keys(Verbiage));
    locales.forEach((lang) => {
        const translations = translationsByLocale[lang];
        if (!translations) {
            console.warn(`File does not exist for language: ${lang}`);
            return;
        }
        const orphanKeys = Object.keys(translations).filter((key) => !enumKeys.has(key));
        if (orphanKeys.length > 0) {
            console.warn(`Orphan keys in ${lang}/global.json:`, orphanKeys);
        }
        else {
            console.log(`No orphan keys in ${lang}/global.json`);
        }
    });
}
